import React from "react";
import { Eye, Heart, Ticket, Users } from "lucide-react";
import { buildConversionStages, compactNumber } from "../../utils/viewersDeskHelpers";

const AudienceConversionCard = ({ dashboard, compact = false }) => {
  const conv = buildConversionStages(dashboard);
  const top = Math.max(conv.viewers, conv.followers, conv.bettors, 1);

  const stages = [
    {
      id: "viewers",
      Icon: Eye,
      label: "Viewers",
      value: conv.viewers,
      fill: "",
      hint:
        conv.totalViews > 0
          ? `${compactNumber(conv.totalViews)} views`
          : "Top",
    },
    {
      id: "followers",
      Icon: Heart,
      label: "Followers",
      value: conv.followers,
      fill: "aud-funnel-fill-followers",
      hint: conv.followRate != null ? `${conv.followRate}%` : "—",
    },
    {
      id: "bettors",
      Icon: Users,
      label: "Bettors",
      value: conv.bettors,
      fill: "aud-funnel-fill-bettors",
      hint: conv.betRate != null ? `${conv.betRate}%` : "—",
    },
  ];

  return (
    <section
      className={`aud-card${compact ? " aud-card-compact" : ""}`}
      aria-label="Attention to action funnel"
    >
      <div className="aud-funnel-head">
        <div>
          <span className="aud-kicker">Conversion</span>
          {!compact ? (
            <p className="aud-caption">Viewers who become followers, then bettors</p>
          ) : null}
        </div>
        <span className="aud-funnel-tickets tabular-nums">
          <Ticket size={10} />
          {compactNumber(conv.totalTickets)} tix
        </span>
      </div>

      {!dashboard ? (
        <p className="aud-funnel-summary aud-funnel-summary-compact">Loading…</p>
      ) : !conv.hasAny ? (
        <p className="aud-funnel-summary aud-funnel-summary-compact">No funnel data yet.</p>
      ) : (
        <div className={`aud-funnel${compact ? " aud-funnel-compact" : ""}`}>
          {stages.map((stage) => (
            <div key={stage.id} className="aud-funnel-stage">
              <div className="aud-funnel-meta">
                <span className="aud-funnel-label">
                  <stage.Icon size={compact ? 9 : 11} />
                  {stage.label}
                </span>
                <strong className="tabular-nums">{stage.value.toLocaleString()}</strong>
              </div>
              <div className="aud-funnel-track">
                <span
                  className={`aud-funnel-fill ${stage.fill}`.trim()}
                  style={{
                    width: `${Math.max((stage.value / top) * 100, stage.value > 0 ? 5 : 0)}%`,
                  }}
                />
              </div>
              <span className="aud-funnel-hint">{stage.hint}</span>
            </div>
          ))}
        </div>
      )}

      {!compact && conv.overallRate != null ? (
        <p className="aud-funnel-summary">
          End to end, <strong>{conv.overallRate}%</strong> of viewers go on to place a bet.
        </p>
      ) : null}
    </section>
  );
};

export default AudienceConversionCard;
